import { inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { DashboardService } from './dashboard.service';

import { ProjectGetDTO } from '../project/project.model';
import { ClientGetDTO } from '../clients/client.model';
import { UserGetDTO } from '../users/users.model';
import { InvoiceGetDTO } from '../invoices/invoice.model';
import { ApiResponseModel } from '../../core/api-response.model';

@Injectable({ providedIn: 'root' })
export class DashboardResolver implements Resolve<any> {
  constructor(private dashboardService: DashboardService) {}

  resolve(): Observable<{
    project: ApiResponseModel<ProjectGetDTO>;
    clients: ApiResponseModel<ClientGetDTO>;
    users: ApiResponseModel<UserGetDTO>;
    invoices: ApiResponseModel<InvoiceGetDTO>;
  }> {
    return this.dashboardService.getDashboardData({
      page: 1,
      limit: 10,
    });
  }
}
